import { z } from "zod";

import { CouponSchema } from "../../../schemas/stripe";

export const GetCouponRequestPathParamSchema = z.object({
  code: z.string(),
});

export type GetCouponRequestPathParamType = z.infer<
  typeof GetCouponRequestPathParamSchema
>;

export const GetCouponResponseBodySchema = z.object({
  coupon: CouponSchema.nullish(),
});

export type GetCouponResponseBodyType = z.infer<
  typeof GetCouponResponseBodySchema
>;
